module.exports = __webpack_public_path__ + "img/KSC08314.4bbfd215.jpg";